Component({
  behaviors: [],
  properties: {
    type: {
      type: String,
      value: 'primary',
    }
  },
})
